import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import Remume from '../../../components/saude/remume';


function RemumeScreen() {
    return (
        <Fragment>
            <Head titulo="Relação Municipal de Medicamentos Essenciais" />
            <Header />
            <Container>
               <Remume /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RemumeScreen;